(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kenai-premium-offer"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',event=>{
 const button=event.target.closest('[data-kenai-rail-step]');
 if(!button)return;
 const rail=button.closest('.kenai-rail-controls').nextElementSibling;
 if(!rail?.classList.contains('kenai-atelier__rail'))return;
 rail.scrollBy({left:Number(button.dataset.kenaiRailStep)*Math.max(220,rail.clientWidth*.8),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
});




  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
